var exports = {
  "wx": "x31de4314--68aa94--header",
  "iE": "x31de4314--68aa94--wrapper",
  "Qs": "x31de4314--68aa94--content",
};

module.exports = exports;
